const dataAggregatorOptions: { [key: string]: string } = {
  Flinks: 'Flinks',
  Plaid: 'Plaid',
  Inverite: 'Inverite',
  MX: 'MX',
  Yodlee: 'Yodlee',
  Other: 'Other',
};

export default dataAggregatorOptions;
